<template>
  <el-container class="group-page" :class="{ 'h5-detail-open': h5DetailOpen }">
    <el-aside width="260px" class="group-list-box">
      <div class="group-list-header">
        <el-input
          class="search-text"
          size="small"
          placeholder="搜索"
          v-model="searchText"
        >
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
        <div class="header-actions">
          <el-button
            plain
            class="icon-btn"
            icon="el-icon-refresh"
            title="刷新群聊列表"
            :loading="refreshGroupLoading"
            @click="onRefreshGroupList"
          ></el-button>
        </div>
      </div>
      <div class="group-list-items">
        <div class="group-top-actions">
          <div class="group-top-item" @click="openJoinGroupDialog">
            <div class="group-top-item-avatar">
              <i class="el-icon-connection"></i>
            </div>
            <div class="group-top-item-name">加入群聊</div>
          </div>
          <div class="group-top-item" @click="onCreateGroup()">
            <div class="group-top-item-avatar">
              <i class="el-icon-plus"></i>
            </div>
            <div class="group-top-item-name">创建群聊</div>
          </div>
          <div class="group-top-item" :class="{ active: showJoinRequestPanel }" @click="onShowJoinRequestPanel">
            <div class="group-top-item-avatar">
              <i class="el-icon-document"></i>
              <span v-if="groupApplyCount > 0" class="top-audit-badge">
                {{ groupApplyCount > 99 ? '99+' : groupApplyCount }}
              </span>
            </div>
            <div class="group-top-item-name">入群申请</div>
          </div>
        </div>
        <div class="divider"></div>
        <virtual-scroller
          class="group-virtual-list"
          :items="groupListRows"
          :get-item-height="getGroupRowHeight"
          item-key="key"
        >
          <template v-slot="{ item }">
            <div v-if="item.rowType === 'index'" class="index-title">{{ item.letter }}</div>
            <group-item
              v-else
              :group="item.group"
              :active="item.group.id == activeGroup.id"
              @click.native="onActiveItem(item.group)"
            >
            </group-item>
          </template>
        </virtual-scroller>
      </div>
    </el-aside>
    <el-container v-if="showJoinRequestPanel" class="group-box">
      <div class="group-header group-request-header">
        <div class="group-header-left">
          <span class="h5-back" title="返回" @click="onH5Back"><i class="el-icon-arrow-left"></i></span>
          <span>入群申请</span>
        </div>
        <el-button size="mini" icon="el-icon-refresh" :loading="joinRecordLoading" @click="loadJoinRequestRecords">刷新</el-button>
      </div>
      <div class="group-request-box" v-loading="joinRecordLoading">
        <el-tabs v-model="joinRecordTab" type="card">
          <el-tab-pane :label="`全部入群申请(${allJoinRecords.length})`" name="all">
            <el-scrollbar v-if="allJoinRecords.length" class="request-list">
              <div class="group-request-item" v-for="item in allJoinRecords" :key="`all-${item.id}`">
                <head-image
                  :size="56"
                  :url="item.groupHeadImage"
                  :name="item.groupName"
                ></head-image>
                <div class="request-info">
                  <div class="nick-name">
                    申请群聊：{{ item.groupName || "-" }} <span class="uid">(群ID: {{ item.groupId || "-" }})</span>
                  </div>
                  <div class="info-text">申请用户：{{ item.sendNickName  }}<span class="uid">（用户ID: {{ item.sendId || "-" }}）</span></div>
                  <div class="info-text">
                    {{ item.remark || "申请加入群聊" }}
                  </div>
                  <div class="info-text">
                    申请时间：{{ formatJoinApplyTime(item) }}
                  </div>
                </div>
                <div class="btn-group">
                  <template>
                    <el-button
                      size="mini"
                      type="success"
                      :loading="joinAuditLoadingId === item.id && joinAuditLoadingApproved === true"
                      @click="onAuditJoinApply(item, true)"
                    >
                      通过
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      :loading="joinAuditLoadingId === item.id && joinAuditLoadingApproved === false"
                      @click="onAuditJoinApply(item, false)"
                    >
                      拒绝
                    </el-button>
                  </template>
                </div>
              </div>
            </el-scrollbar>
            <no-data-tip v-else class="no-data-tip"></no-data-tip>
          </el-tab-pane>
          <el-tab-pane :label="`我发起的申请(${myJoinRecords.length})`" name="mine">
            <el-scrollbar v-if="myJoinRecords.length" class="request-list">
              <div class="group-request-item" v-for="item in myJoinRecords" :key="`mine-${item.id}`">
                <head-image
                  :size="56"
                  :url="item.groupHeadImage || item.headImage"
                  :name="item.groupName || item.showGroupName || `群${item.groupId || ''}`"
                ></head-image>
                <div class="request-info">
                  <div class="nick-name">{{ item.groupName || "未知群聊" }}<span class="uid">(群ID: {{ item.groupId || "-" }})</span></div>
                  <div class="info-text">
                    {{ item.remark || "申请加入该群聊" }}
                  </div>
                  <div class="info-text">
                    申请时间：{{ formatJoinApplyTime(item) }}
                  </div>
                </div>
                <div class="btn-group">
                  <el-tag size="medium" :type="joinStatusTagType(item.status)">{{ joinStatusText(item.status) }}</el-tag>
                </div>
              </div>
            </el-scrollbar>
            <no-data-tip v-else class="no-data-tip"></no-data-tip>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-container>
    <el-container v-else class="group-box">
      <div class="group-header" v-show="activeGroup.id">
        <div class="group-header-left">
          <span class="h5-back" title="返回" @click="onH5Back"><i class="el-icon-arrow-left"></i></span>
          <span>{{ activeGroup.showGroupName }}({{ activeGroup.memberCount || groupMembers.length || '...'}})</span>
        </div>
      </div>
      <div class="group-container">
        <div v-show="activeGroup.id">
          <div class="group-info">
            <div>
              <file-upload
                v-if="isOwner || isManager"
                class="avatar-uploader"
                :action="imageAction"
                :isPermanent="true"
                :showLoading="true"
                :maxSize="maxSize"
                @success="onUploadSuccess"
                :fileTypes="[
                  'image/jpeg',
                  'image/png',
                  'image/jpg',
                  'image/webp',
                ]"
              >
                <img
                  v-if="activeGroup.headImage"
                  :src="$mediaUrl(activeGroup.headImage)"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </file-upload>
              <head-image
                v-else
                class="avatar"
                :size="120"
                :url="activeGroup.headImage"
                :name="activeGroup.showGroupName"
                radius="10%"
              >
              </head-image>
              <el-button
                class="send-btn"
                icon="el-icon-position"
                type="primary"
                @click="onSendMessage()"
                >发消息
              </el-button>
            </div>
            <el-form
              class="group-form"
              label-width="130px"
              :model="activeGroup"
              :rules="rules"
              size="small"
              ref="groupForm"
            >
              <el-form-item label="群聊名称" prop="name">
                <el-input
                  v-model="activeGroup.name"
                  :disabled="!isOwner && !isManager"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item label="群ID">
                <el-input :value="activeGroup.id" readOnly></el-input>
              </el-form-item>
              <el-form-item label="群类型">
                <el-input :value="activeGroup.groupType == 1 ? '普通群' : activeGroup.groupType == 2 ? '工作群' : '频道'" disabled />
              </el-form-item>
              <el-form-item label="群主">
                <el-input :value="ownerName" disabled></el-input>
              </el-form-item>
              <el-form-item label="群名备注">
                <el-input
                  v-model="activeGroup.remarkGroupName"
                  :placeholder="activeGroup.name"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="全体禁言"
                title="全员禁言开启后,仅管理员可以发言"
              >
                <el-switch
                  :disabled="!isOwner && !isManager"
                  v-model="activeGroup.isMuted"
                >
                </el-switch>
              </el-form-item>
              <el-form-item
                label="允许加好友"
                title="开启允许加好友后，不限制群成员进行好友添加"
              >
                <el-switch
                  :disabled="!isOwner && !isManager"
                  v-model="activeGroup.isAddFriend"
                >
                </el-switch>
              </el-form-item>
              <el-form-item
                label="允许语音"
                title="开启允许语音后，不限制群成员进行语音通话"
              >
                <el-switch
                  :disabled="!isOwner && !isManager"
                  v-model="activeGroup.isVoiceCall"
                >
                </el-switch>
              </el-form-item>
              <el-form-item
                label="允许邀请"
                title="开启允许邀请后，不限制群成员邀请好友进群"
              >
                <el-switch
                  :disabled="!isOwner && !isManager"
                  v-model="activeGroup.isInviteUser"
                >
                </el-switch>
              </el-form-item>
              <el-form-item
                label="入群审核"
                title="开启入群审核后，邀请好友进群需要审核"
              >
                <el-switch
                  :disabled="!isOwner && !isManager"
                  v-model="activeGroup.isNeedApproval"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="我在本群的昵称">
                <el-input
                  v-model="activeGroup.remarkNickName"
                  maxlength="20"
                  :placeholder="$store.state.userStore.userInfo.nickName"
                ></el-input>
              </el-form-item>
              <el-form-item label="群公告">
                <el-input
                  v-model="activeGroup.notice"
                  :disabled="!isOwner && !isManager"
                  type="textarea"
                  :rows="3"
                  maxlength="1024"
                  placeholder="群主未设置"
                ></el-input>
              </el-form-item>
              <div>
                <el-button type="warning" @click="onInviteMember()" v-if="showInviteBtn"
                  >邀请</el-button
                >
                <el-button type="success" @click="onSaveGroup()"
                  >保存</el-button
                >
                <el-button type="danger" v-show="!isOwner" @click="onQuit()"
                  >退出</el-button
                >
                <el-button type="danger" v-show="isOwner" @click="onDissolve()"
                  >解散</el-button
                >
              </div>
            </el-form>
          </div>
          <el-divider content-position="center"></el-divider>
          <el-scrollbar
            ref="scrollbar"
            :style="'height: ' + scrollHeight + 'px'"
          >
            <div class="group-member-list">
              <div class="member-tools" v-if="showInviteBtn">
                <div
                  class="tool-btn"
                  title="邀请好友进群聊"
                  @click="onInviteMember()"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <div class="tool-text">邀请</div>
                <add-group-member
                  ref="addGroupMember"
                  :groupId="activeGroup.id"
                  :members="groupMembers"
                  @reload="loadGroupMembers"
                ></add-group-member>
              </div>
              <div class="member-tools" v-if="isOwner || isManager">
                <div
                  class="tool-btn"
                  title="选择成员移出群聊"
                  @click="onRemoveMember()"
                >
                  <i class="el-icon-minus"></i>
                </div>
                <div class="tool-text">移除</div>
                <group-member-selector
                  ref="removeSelector"
                  title="选择成员进行移除"
                  :group="activeGroup"
                  @complete="onRemoveComplete"
                ></group-member-selector>
              </div>
              <div class="member-tools" v-if="isOwner || isManager">
                <div class="tool-btn" title="禁言" @click="onMuted()">
                  <span
                    class="icon iconfont icon-chat-muted"
                    style="font-size: 16px"
                  ></span>
                </div>
                <div class="tool-text">禁言</div>
                <group-member-selector
                  ref="mutedSelector"
                  title="选择成员进行禁言"
                  :group="activeGroup"
                  @complete="onMutedComplete"
                ></group-member-selector>
              </div>
              <div class="member-tools" v-if="isOwner || isManager">
                <div class="tool-btn" title="解除禁言" @click="onUnmuted()">
                  <span
                    class="icon iconfont icon-chat-unmuted"
                    style="font-size: 16px"
                  ></span>
                </div>
                <div class="tool-text">解除禁言</div>
                <group-member-selector
                  ref="unmutedSelector"
                  title="选择成员进行解除禁言"
                  :group="activeGroup"
                  @complete="onUnmutedComplete"
                ></group-member-selector>
              </div>
              <div v-for="member in visibleMembers" :key="member.id">
                <group-member-item
                  class="group-member"
                  :group="activeGroup"
                  :groupMembers="groupMembers"
                  :member="member"
                  type="card"
                ></group-member-item>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-container>
    <el-dialog
      title="加入群聊"
      :visible.sync="showJoinGroupDialog"
      width="560px"
      @close="onJoinDialogClosed"
    >
      <div class="group-find-box">
        <el-input
          size="small"
          v-model.trim="findGroupId"
          placeholder="输入群ID查询"
          type="tel"
          clearable
          @keyup.enter.native="onFindGroupById"
        >
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
        <el-button
          size="small"
          type="primary"
          :loading="findGroupLoading"
          @click="onFindGroupById"
        >
          查询
        </el-button>
      </div>
      <div class="find-result-box" v-if="findGroupResult">
        <div class="find-result-body">
          <head-image
            :size="64"
            :url="findGroupResult.headImage"
            :name="findGroupResult.name || findGroupResult.showGroupName"
            radius="12%"
          />
          <div class="find-result-info">
            <div class="find-result-item"><span>群名称：</span>{{ findGroupResult.name || "-" }}</div>
            <div class="find-result-item"><span>群类型：</span>{{ groupTypeText(findGroupResult.groupType) }}</div>
            <div class="find-result-item"><span>群公告：</span>{{ findGroupResult.notice || "暂无公告" }}</div>
            <div class="find-result-item"><span>群ID：</span>{{ findGroupResult.id }}</div>
          </div>
        </div>
        <div class="find-result-actions">
          <el-button
            v-if="!findGroupMineInGroup"
            :type="`${sendJoinApplyFlag ? 'info' : 'success'}`"
            size="small"
            :loading="joinGroupLoading"
            @click="onJoinFoundGroup"
            :disabled="sendJoinApplyFlag"
          >
            {{ sendJoinApplyFlag ? '申请已提交，等待管理员审核' : findGroupResult.isNeedApproval ? '申请加入群聊' : '加入群聊' }}
          </el-button>
          <el-button
            v-else
            type="primary"
            size="small"
            @click="onSendMessageToGroup(findGroupResult)"
          >
            发送消息
          </el-button>
        </div>
      </div>
      <div class="find-empty-tip" v-else>请输入群ID后点击查询</div>
    </el-dialog>
    <chat-selector ref="chatSel" title="分享名片"></chat-selector>
  </el-container>
</template>

<script>
import moment from "moment";
import ChatSelector from "../components/chat/ChatSelector.vue";
import FileUpload from "../components/common/FileUpload";
import HeadImage from "../components/common/HeadImage.vue";
import NoDataTip from "../components/common/NoDataTip.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
import AddGroupMember from "../components/group/AddGroupMember.vue";
import GroupItem from "../components/group/GroupItem";
import GroupMemberItem from "../components/group/GroupMemberItem.vue";
import GroupMemberSelector from "../components/group/GroupMemberSelector.vue";

export default {
  name: "group",
  components: {
    GroupItem,
    GroupMemberItem,
    FileUpload,
    AddGroupMember,
    GroupMemberSelector,
    HeadImage,
    NoDataTip,
    ChatSelector,
    VirtualScroller,
  },
  data() {
    return {
      searchText: "",
      refreshGroupLoading: false,
      showJoinGroupDialog: false,
      findGroupId: "",
      findGroupResult: null,
      findGroupMineInGroup: false,
      findGroupLoading: false,
      joinGroupLoading: false,
      maxSize: 5 * 1024 * 1024,
      activeGroup: {},
      groupMembers: [],
      showMaxIdx: 150,
      sendJoinApplyFlag: false,
      shareGroupCardLoading: false,
      showJoinRequestPanel: false,
      joinRecordTab: "all",
      joinRecordLoading: false,
      joinAuditLoadingId: null,
      joinAuditLoadingApproved: null,
      moment,
      rules: {
        name: [
          {
            required: true,
            message: "请输入群聊名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onRefreshGroupList() {
      if (this.refreshGroupLoading) {
        return;
      }
      this.refreshGroupLoading = true;
      this.$store.dispatch("loadGroup").then(() => {
        this.$message.success("群聊列表已刷新");
        if (this.activeGroup && this.activeGroup.id) {
          const latest = this.$store.getters.findGroup(this.activeGroup.id);
          if (latest && !latest.quit) {
            this.onActiveItem(latest);
          } else {
            this.reset();
          }
        }
      }).finally(() => {
        this.refreshGroupLoading = false;
      });
      this.loadJoinRequestRecords();
    },
    openJoinGroupDialog() {
      this.showJoinGroupDialog = true;
      this.findGroupId = "";
      this.findGroupResult = null;
      this.findGroupMineInGroup = false;
    },
    onJoinDialogClosed() {
      this.findGroupLoading = false;
      this.joinGroupLoading = false;
      this.sendJoinApplyFlag = false;
    },
    onCreateGroup() {
      this.$prompt("请输入群聊名称", "创建群聊", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入群聊名称",
      }).then((o) => {
        let data = {
          name: o.value,
        };
        this.$http({
          url: `/group/create?groupName=${o.value}`,
          method: "post",
          data: data,
        }).then((group) => {
          this.$store.commit("addGroup", group);
          this.onActiveItem(group)
          this.$message.success('创建成功');
        });
      });
    },
    onActiveItem(group) {
      this.showMaxIdx = 150;
      this.showJoinRequestPanel = false;
      // store数据不能直接修改，所以深拷贝一份内存
      this.activeGroup = JSON.parse(JSON.stringify(group));
      // 重新加载群成员
      this.groupMembers = [];
      this.loadGroupMembers();
    },
    onShowJoinRequestPanel() {
      this.reset();
      this.showJoinRequestPanel = true;
    },
    formatJoinApplyTime(item) {
      const time = item && (item.applyTime || item.inviteTime || item.createTime || item.createTimeStamp || item.updateTime);
      if (!time) {
        return "-";
      }
      return this.moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    joinStatusText(status) {
      if (status == 1) return "待审核";
      if (status == 2) return "已通过";
      if (status == 3) return "已拒绝";
      return "未知状态";
    },
    joinStatusTagType(status) {
      if (status == 1) return "warning";
      if (status == 2) return "success";
      if (status == 3) return "danger";
      return "info";
    },
    loadJoinRequestRecords() {
      this.$store.dispatch("loadGroupJoinRequests").catch(() => { });
      this.$store.dispatch("loadMyJoinRequests").catch(() => { });
    },
    onAuditJoinApply(item, approved) {
      if (!item || !item.id) {
        return;
      }
      this.joinAuditLoadingId = item.id;
      this.joinAuditLoadingApproved = approved;
      this.$http({
        url: "/group/join/audit",
        method: "post",
        data: {
          id: item.id,
          approved: !!approved,
        },
      }).then(() => {
        this.$message.success(approved ? "已通过申请" : "已拒绝申请");
        this.$store.commit("removeJoinRequest", item);
      }).finally(() => {
        this.joinAuditLoadingId = null;
        this.joinAuditLoadingApproved = null;
      });
    },
    onJoinAuditUpdated() {
      this.loadGroupMembers();
    },
    onInviteMember() {
      this.$refs.addGroupMember.open();
    },
    onRemoveMember() {
      // 群主和自己不显示
      let hideIds = [this.activeGroup.ownerId, this.mine.id];
      // 只有群主可以移除管理员
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      this.$refs.removeSelector.open(50, [], [], hideIds);
    },
    onRemoveComplete(members) {
      let userIds = members.map((m) => m.userId);
      let data = {
        groupId: this.activeGroup.id,
        userIds: userIds,
      };
      this.$http({
        url: "/group/members/remove",
        method: "delete",
        data: data,
      }).then(() => {
        this.loadGroupMembers();
        this.$message.success(`您移除了${userIds.length}位成员`);
      });
    },
    onMuted() {
      // 群主和自己不显示
      let hideIds = [this.activeGroup.ownerId, this.mine.id];
      // 只有群主可以禁言管理员
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      // 已禁言的用户不可选中
      let lockedIds = this.groupMembers
        .filter((m) => m.isMuted)
        .map((m) => m.userId);
      this.$refs.mutedSelector.open(50, [], lockedIds, hideIds);
    },
    onMutedComplete(members) {
      let userIds = members.map((m) => m.userId);
      let data = {
        groupId: this.activeGroup.id,
        userIds: userIds,
        isMuted: true,
      };
      let tip = `您对${userIds.length}位成员进行了禁言`;
      this.sendMemberMuted(data, tip);
    },
    onUnmuted() {
      // 过滤掉未禁言的用户
      let hideIds = this.groupMembers
        .filter((m) => !m.isMuted)
        .map((m) => m.userId);
      // 只有群主可以解除管理员的禁言
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      this.$refs.unmutedSelector.open(50, [], [], hideIds);
    },
    onUnmutedComplete(members) {
      let userIds = members.map((m) => m.userId);
      let data = {
        groupId: this.activeGroup.id,
        userIds: userIds,
        isMuted: false,
      };
      let tip = `您解除了${userIds.length}位成员的禁言`;
      this.sendMemberMuted(data, tip);
    },
    onCloseAddGroupMember() {
      this.showAddGroupMember = false;
    },
    onUploadSuccess(data) {
      this.activeGroup.headImage = data.originUrl;
      this.activeGroup.headImageThumb = data.originUrl;
    },
    onSaveGroup() {
      this.$refs["groupForm"].validate((valid) => {
        if (valid) {
          let vo = this.activeGroup;
          console.log(vo);
          this.$http({
            url: "/group/modify",
            method: "put",
            data: vo,
          }).then((group) => {
            this.$store.commit("updateGroup", group);
            this.$message.success("修改成功");
          });
        }
      });
    },
    onDissolve() {
      this.$confirm(`确认要解散'${this.activeGroup.name}'吗?`, "确认解散?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: `/group/delete/${this.activeGroup.id}`,
          method: "delete",
        }).then(() => {
          this.$message.success(`群聊'${this.activeGroup.name}'已解散`);
          this.$store.commit("removeGroup", this.activeGroup.id);
          this.reset();
        });
      });
    },
    onQuit() {
      this.$confirm(
        `确认退出'${this.activeGroup.showGroupName}',并清空聊天记录吗？`,
        "确认退出?",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$http({
          url: `/group/quit/${this.activeGroup.id}`,
          method: "delete",
        }).then(() => {
          this.$message.success(`您已退出'${this.activeGroup.name}'`);
          this.$store.commit("removeGroup", this.activeGroup.id);
          this.$store.commit("removeGroupChat", this.activeGroup.id);
          this.reset();
        });
      });
    },
    onSendMessage() {
      this.onSendMessageToGroup(this.activeGroup);
    },
    onShareGroupCard() {
      if (!this.activeGroup || !this.activeGroup.id || this.shareGroupCardLoading) {
        return;
      }
      const cardContent = JSON.stringify({
        groupId: this.activeGroup.id,
        groupName: this.activeGroup.name || this.activeGroup.showGroupName || "",
        headImage: this.activeGroup.headImage || "",
      });
      this.$refs.chatSel.open((chats) => {
        this.shareGroupCardLoading = true;
        const tasks = chats.map((chat) => {
          const isGroup = chat.type === "GROUP";
          const data = {
            content: cardContent,
            type: this.$enums.MESSAGE_TYPE.GROUP_CARD,
            recvId: isGroup ? "" : chat.targetId,
            groupId: isGroup ? chat.targetId : "",
          };
          return this.$http({
            url: `/message/${chat.type.toLowerCase()}/send`,
            method: "post",
            data,
          }).then((m) => {
            m.selfSend = true;
            this.$store.commit("openChat", chat);
            this.$store.commit("insertMessage", [m, chat]);
            return true;
          }).catch(() => false);
        });
        Promise.all(tasks).then((results) => {
          const successCount = results.filter(Boolean).length;
          if (successCount === chats.length) {
            this.$message.success("分享成功");
            return;
          }
          if (successCount > 0) {
            this.$message.warning(`已成功分享${successCount}个会话，部分发送失败`);
            return;
          }
        }).finally(() => {
          this.shareGroupCardLoading = false;
        });
      });
    },
    onSendMessageToGroup(group) {
      if (!group || !group.id) {
        return;
      }
      let chat = {
        type: "GROUP",
        targetId: group.id,
        showName: group.showGroupName || group.name,
        headImage: group.headImage,
      };
      this.$store.commit("openChat", { ...chat, activeChat: true });
      this.$router.push("/home/chat");
    },
    groupTypeText(groupType) {
      if (groupType == 1) return "普通群";
      if (groupType == 2) return "工作群";
      if (groupType == 3) return "频道";
      return "未知";
    },
    onFindGroupById() {
      const groupId = (this.findGroupId || "").trim();
      this.sendJoinApplyFlag = false;
      if (!groupId) {
        this.$message.warning("请输入群ID");
        return;
      }
      this.findGroupLoading = true;
      this.findGroupResult = null;
      this.findGroupMineInGroup = false;
      this.$http({
        url: `/group/find/${groupId}`,
        method: "get",
      })
        .then((group) => {
          this.findGroupResult = group;
          return this.$http({
            url: `/group/members/${group.id}`,
            method: "get",
          });
        })
        .then((members) => {
          this.findGroupMineInGroup = (members || []).some(
            (m) => m.userId == this.mine.id && !m.quit
          );
        })
        .finally(() => {
          this.findGroupLoading = false;
        });
    },
    onJoinFoundGroup() {
      if (!this.findGroupResult || !this.findGroupResult.id) {
        return;
      }
      const groupId = this.findGroupResult.id;
      this.joinGroupLoading = true;
      this.$http({
        url: `/group/join/${groupId}`,
        method: "post",
      })
        .then(() => {
          if (this.findGroupResult.isNeedApproval) {
            this.$message.success("申请已提交，等待管理员审核");
            this.$store.dispatch("loadMyJoinRequests", this.findGroupResult);
            this.sendJoinApplyFlag = true;
          } else {
            this.onActiveItem(this.findGroupResult);
            this.$message.success("加入群聊成功");
            this.showJoinGroupDialog = false;
          }
        })
        .finally(() => {
          this.joinGroupLoading = false;
        });
    },
    onScroll(e) {
      const scrollbar = e.target;
      // 滚到底部
      if (
        scrollbar.scrollTop + scrollbar.clientHeight >=
        scrollbar.scrollHeight - 30
      ) {
        if (this.showMaxIdx < this.showMembers.length) {
          this.showMaxIdx += 50;
        }
      }
    },
    sendMemberMuted(data, tip) {
      this.$http({
        url: "/group/members/muted",
        method: "put",
        data: data,
      }).then(() => {
        this.loadGroupMembers();
        this.$message.success(tip);
      });
    },
    onGroupMemberMuted(payload) {
      if (!payload || !this.activeGroup || this.activeGroup.id != payload.groupId) {
        return;
      }
      const member = (this.groupMembers || []).find((m) => m.userId == payload.userId);
      if (member) {
        this.$set(member, "isMuted", payload.isMuted);
      }
    },
    loadGroupMembers() {
      this.$http({
        url: `/group/members/${this.activeGroup.id}`,
        method: "get",
      }).then((members) => {
        this.groupMembers = members;
      });
    },
    reset() {
      this.activeGroup = {};
      this.groupMembers = [];
    },
    onH5Back() {
      this.reset();
      this.showJoinRequestPanel = false;
    },
    getGroupRowHeight(row) {
      return row && row.rowType === "index" ? 28 : 60;
    },
  },
  computed: {
    mine() {
      return this.$store.state.userStore.userInfo;
    },
    h5DetailOpen() {
      return this.showJoinRequestPanel || !!(this.activeGroup && this.activeGroup.id);
    },
    groupStore() {
      return this.$store.state.groupStore;
    },
    ownerName() {
      let member = this.groupMembers.find(
        (m) => m.userId == this.activeGroup.ownerId
      );
      return member && member.showNickName;
    },
    isOwner() {
      return this.activeGroup.ownerId == this.mine.id;
    },
    isManager() {
      let userId = this.mine.id;
      let m = this.groupMembers.find((m) => m.userId == userId);
      return m && m.isManager;
    },
    showInviteBtn() {
      if (this.isOwner || this.isManager || this.activeGroup.isInviteUser) {
        return true;
      }
      return false;
    },
    managerIds() {
      return this.groupMembers.filter((m) => m.isManager).map((m) => m.userId);
    },
    imageAction() {
      return `/image/upload`;
    },
    groupListRows() {
      const map = new Map();
      const keyword = this.searchText || "";
      const groups = this.groupStore.groups || [];
      for (let i = 0; i < groups.length; i++) {
        const g = groups[i];
        if (!g || g.quit || (keyword && !(g.showGroupName || "").includes(keyword))) {
          continue;
        }
        const letter = g.letter || "#";
        if (map.has(letter)) {
          map.get(letter).push(g);
        } else {
          map.set(letter, [g]);
        }
      }
      const keys = Array.from(map.keys()).sort((a, b) => {
        if (a == "#" || b == "#") {
          return b.localeCompare(a);
        }
        return a.localeCompare(b);
      });
      const rows = [];
      for (let i = 0; i < keys.length; i++) {
        const letter = keys[i];
        rows.push({ rowType: "index", key: "h-" + letter, letter });
        const list = map.get(letter);
        for (let j = 0; j < list.length; j++) {
          const group = list[j];
          rows.push({ rowType: "group", key: group.id, group });
        }
      }
      return rows;
    },
    visibleMembers() {
      return this.showMembers.slice(0, this.showMaxIdx);
    },
    showMembers() {
      let list = this.groupMembers.filter((m) => !m.quit)
			if (this.activeGroup.groupType == 3) {
				if (!(this.isOwner || this.isManager)) {
					list = list.filter((m) => m.userId == this.activeGroup.ownerId || m.isManager || m.userId == this.mine.id);
				}
			}
			return list;
    },
    scrollHeight() {
      return Math.min(300, 80 + (this.showMembers.length / 10) * 80);
    },
    groupApplyCount() {
			return this.$store.state.groupStore.joinRequests.length;
		},
    allJoinRecords() {
      return this.$store.state.groupStore.joinRequests;
    },
    myJoinRecords() {
      return this.$store.state.groupStore.myJoinRequests;
    },
  },
  mounted() {
    let scrollWrap = this.$refs.scrollbar.$el.querySelector(
      ".el-scrollbar__wrap"
    );
    scrollWrap.addEventListener("scroll", this.onScroll);
    this.$eventBus && this.$eventBus.$on("group:member-muted", this.onGroupMemberMuted);
  },
  beforeDestroy() {
    this.$eventBus && this.$eventBus.$off("group:member-muted", this.onGroupMemberMuted);
  },
};
</script>

<style lang="scss">
.group-page {
  height: 100%;

  .divider {
    border-bottom: 1px #ddd solid;
    margin: 10px;
  }

  .group-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);
    height: 100%;
    overflow: hidden;

    .group-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;

      .header-actions {
        display: flex;
        align-items: center;
      }

      .icon-btn {
        padding: 5px !important;
        margin-left: 6px;
        font-size: 16px;
        border-radius: 50%;
      }
    }

    .group-list-items {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;

      .group-virtual-list {
        flex: 1;
        min-height: 0;
      }

      .group-top-actions {
        padding: 8px 10px;
      }

      .group-top-item {
        display: flex;
        align-items: center;
        height: 48px;
        border-radius: 6px;
        cursor: pointer;
        padding: 0 10px;

        &:hover {
          background-color: var(--im-background-active);
        }

        &.active {
          background-color: var(--im-background-active-dark);
        }

        .group-top-item-avatar {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: #ecf5ff;
          color: var(--im-color-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          position: relative;

          .top-audit-badge {
            position: absolute;
            top: -6px;
            right: -8px;
            min-width: 18px;
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
            background: #f56c6c;
            color: #fff;
            font-size: 11px;
            text-align: center;
            padding: 0 4px;
            box-sizing: border-box;
          }
        }

        .group-top-item-name {
          margin-left: 10px;
          font-size: var(--im-font-size);
          color: var(--im-text-color);
        }
      }

      .index-title {
        text-align: left;
        font-size: var(--im-larger-size-larger);
        margin: 5px 15px;
        color: var(--im-text-color-light);
      }
    }
  }

  .group-box {
    display: flex;
    flex-direction: column;

    .group-header {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      line-height: 50px;
      font-size: var(--im-font-size-larger);
      border-bottom: var(--im-border);
    }

    .group-request-header {
      align-items: center;
    }

    .el-divider--horizontal {
      margin: 16px 0;
    }

    .group-container {
      overflow: auto;
      padding: 20px;
      flex: 1;

      .group-info {
        display: flex;
        padding: 5px 20px;

        .group-form {
          flex: 1;
          padding-left: 40px;
          max-width: 700px;

          .el-form-item {
            text-align: left;
          }
        }

        .avatar-uploader {
          --width: 120px;
          text-align: left;

          .el-upload {
            border: 1px dashed #d9d9d9 !important;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          .el-upload:hover {
            border-color: #409eff;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: var(--width);
            height: var(--width);
            line-height: var(--width);
            text-align: center;
          }

          .avatar {
            width: var(--width);
            height: var(--width);
            display: block;
          }
        }

        .send-btn {
          margin-top: 12px;
        }
      }

      .group-member-list {
        padding: 4px 12px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;

        .group-member {
          margin-right: 5px;
        }

        .member-tools {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 60px;

          .tool-btn {
            width: 38px;
            height: 38px;
            line-height: 38px;
            border: var(--im-border);
            font-size: 14px;
            cursor: pointer;
            box-sizing: border-box;
            position: relative;

            &:hover {
              border: #aaaaaa solid 1px;
            }

            .audit-badge {
              position: absolute;
              top: -6px;
              right: -8px;
              min-width: 18px;
              height: 18px;
              line-height: 18px;
              border-radius: 9px;
              background: #f56c6c;
              color: #fff;
              font-size: 11px;
              text-align: center;
              padding: 0 4px;
              box-sizing: border-box;
            }
          }

          .tool-text {
            font-size: var(--im-font-size-smaller);
            text-align: center;
            width: 100%;
            height: 30px;
            line-height: 30px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }

    .group-request-box {
      flex: 1;
      padding: 12px;

      .request-list {
        max-height: calc(100vh - 200px);
        overflow: auto;
      }

      .group-request-item {
        min-height: 88px;
        display: flex;
        align-items: center;
        position: relative;
        margin: 2px 30px;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;

        .request-info {
          margin-left: 15px;
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .nick-name {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 16px;
            line-height: 30px;
          }

          .info-text {
            display: flex;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            word-break: break-all;
          }

          .uid {
            color: #909399;
            font-size: 14px;
            font-weight: normal;
          }
        }

        .btn-group {
          margin-left: 12px;
          white-space: nowrap;
        }
      }
    }
  }
}

.group-find-box {
  display: flex;
  gap: 8px;
  align-items: center;
}

.find-result-box {
  margin-top: 12px;
  border: var(--im-border);
  padding: 12px;
  background: #fafbfd;
  border-radius: 8px;

  .find-result-header {
    font-size: var(--im-font-size-small);
    color: var(--im-text-color-light);
    margin-bottom: 10px;
  }

  .find-result-body {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }

  .find-result-info {
    flex: 1;
    min-width: 0;
  }

  .find-result-item {
    font-size: var(--im-font-size-small);
    line-height: 1.7;
    word-break: break-all;

    span {
      color: var(--im-text-color-light);
    }
  }

  .find-result-actions {
    margin-top: 12px;
    text-align: right;
  }
}

.find-empty-tip {
  padding: 24px 0;
  margin-top: 12px;
  color: var(--im-text-color-light);
  font-size: var(--im-font-size-small);
}
</style>
